import { Label } from '@/components/shadcn/ui/label';
import { RadioGroup, RadioGroupItem } from '@/components/shadcn/ui/radio-group';

import { useFieldContext } from './form';
import { getFieldError } from './get-field-error';

export interface RadioGroupItem {
  value: string;
  label: string;
}

interface FormRadioGroupProps {
  items: RadioGroupItem[];
  showErrorMessage?: boolean;
  className?: string;
  orientation?: 'horizontal' | 'vertical';
}

export function FormRadioGroup({
  items,
  showErrorMessage = true,
  className,
  orientation = 'vertical',
}: FormRadioGroupProps) {
  const field = useFieldContext<string>();

  return (
    <div className="flex flex-col gap-2">
      <RadioGroup
        value={field.state.value ?? ''}
        onValueChange={(value) => field.handleChange(value)}
        className={className}
        orientation={orientation}
      >
        {items.map((item) => (
          <div key={item.value} className="flex items-center gap-2">
            <RadioGroupItem
              value={item.value}
              id={`${field.name}-${item.value}`}
            />
            <Label
              htmlFor={`${field.name}-${item.value}`}
              className="cursor-pointer"
            >
              {item.label}
            </Label>
          </div>
        ))}
      </RadioGroup>
      {showErrorMessage && field.state.meta.errors.length > 0 && (
        <span className="text-destructive text-sm">
          {getFieldError(field.state.meta.errors[0])}
        </span>
      )}
    </div>
  );
}
